import React from 'react';

import LanguageSelect from './LanguageSelect';
import BasketButton from '../Basket/BasketButton';
import StepsHeader, { StepsHeaderProps } from './StepsHeader';

type PageHeaderProps = Omit<StepsHeaderProps, 'displayHelp'> & {
  displayBasket?: boolean;
  hideHelp?: boolean;
  hideLanguageSelect?: boolean;
};

const PageHeader: React.FC<PageHeaderProps> = ({
  currentIndex,
  length,
  title,
  onPrev,
  hideHelp,
  hideSteps,
  hidePrevButton,
  displayBasket,
  hideLanguageSelect,
}) => (
  <header className="w-full flex justify-between items-center sm:gap-3 z-30 px-8 kioskPartteam:px-14 kioskSharebox:px-6 sm:px-7 fixed bg-white/90 backdrop-blur-xs" id="header">
    <StepsHeader
      title={title}
      currentIndex={currentIndex}
      length={length}
      onPrev={onPrev}
      hideSteps={hideSteps}
      hidePrevButton={hidePrevButton}
      displayHelp={!hideHelp}
    />
    <div className="flex items-center flex-1 justify-end gap-8 kioskPartteam:gap-10 kioskSharebox:gap-5 sm:contents">
      {displayBasket && <div className="sm:order-3"><BasketButton /></div>}
      {!hideLanguageSelect && <div className="sm:order-5"><LanguageSelect /></div>}
    </div>
  </header>
);

export default PageHeader;
